import { render, staticRenderFns } from "./SolicitudRegistrar.vue?vue&type=template&id=cd2ac520"
import script from "./SolicitudRegistrar.vue?vue&type=script&lang=js"
export * from "./SolicitudRegistrar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports